
<p *ngIf="typeMessage && !useGcWeb">
  <span class="badge badge-info">{{ typeMessage | translate }}</span>
</p>

<p *ngIf="typeMessage && useGcWeb">
  <strong class="label label-info">{{ typeMessage | translate }}</strong>
</p>